module.exports = __webpack_public_path__ + "assets/dbe24edca22b750143ff83a2d0122c15.mp3";